<template>
    <div class="cs-studyAbroadAccountListSaleAmountCell">
        <span>{{ data.SaleAmountDiscounted | toCurrency(data.Currency) }}</span>
        <div v-if="data.SaleAmount != data.SaleAmountDiscounted">
          <span>原价:{{ data.SaleAmount | toCurrency(data.Currency) }}</span>
          <span v-if="data.DiscountAmount > 0">折扣:-{{ data.DiscountAmount | toCurrency(data.Currency) }}</span>
          <span v-if="data.CashDecreasedAmount > 0">现金减:-{{ data.CashDecreasedAmount | toCurrency(data.Currency) }}</span>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.cs-studyAbroadAccountListSaleAmountCell{
  span{
    display: block;
  }
}
</style>

<script>

export default {
  props: {
    data: {},
    columnData:{},
    status: {}
  },
  data() {
    return {
    }
  },
  components: {},
  created() {
    
  },
  methods: {
    
  },
  watch: {
    data: function() {
      
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/studyAbroadAccountListSaleAmountCell.vue